import { sizeNumeric } from "@izettle/otto"

export const FOCUS_BORDER_WIDTH = "2px"
export const ZINDEX_SINGLE_SELECT_POP_OVER = 20
export const ZINDEX_SINGLE_SELECT_INPUT_FOCUSED = 30
export const ZINDEX_SINGLE_SELECT_POP_OVER_FULLSCREEN = 100
export const CALENDAR_PADDING_SIZE = sizeNumeric.xSmall
export const CALENDAR_ROW_HEIGHT = 44
